module.exports = __webpack_public_path__ + "static/media/Group 32.9dc4025a.svg";